import { gql } from '@grandvisionhq/graphql';

/**
 * This Price type is used e.g. in the Offerings object
 */ const productPriceFragment = gql`
  fragment productPriceFragment on ProductPrice {
    value {
      currencyCode
      centAmount
    }
    discounted {
      value {
        centAmount
        currencyCode
      }
    }
  }
`;

export { productPriceFragment };
//# sourceMappingURL=productPrice.js.map
